import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import {
  WithdrawalAccountApiResponse,
  WithdrawOptions,
  WithdrawSended
} from './withdraws-bff-types';

const context = '/v1/cash';

export class WithdrawsBFF extends BaseHttpClient {
  constructor() {
    super(undefined, process.env.VUE_APP_BANKING_API_URL);
  }

  public createWithdrawal(
    bankAccountId: string,
    withdrawAmount: number
  ): Promise<WithdrawSended> {
    return this.post(`${context}/createWithdrawal`, {
      bankAccountId,
      withdrawAmount
    });
  }

  public getWithdrawSuggestions(): Promise<WithdrawOptions> {
    return this.get(`${context}/getWithdrawSuggestions`);
  }

  public getWithdrawOptions(): Promise<WithdrawOptions> {
    return this.get<WithdrawOptions>(`${context}/getWithdrawOptions`);
  }

  public getWithdrawAccount(
    transactionId: string
  ): Promise<WithdrawalAccountApiResponse> {
    return this.get<WithdrawalAccountApiResponse>(
      `${context}/getWithdrawalReceipt/${transactionId}`
    );
  }
}
